import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {PURCHASE_ORDER_STATUS, TILL_PRICE_CALCULATION_METHOD} from "../../shared/utils/Constants";
import {Fieldset} from "primereact/fieldset";
import DateInput from "../../shared/component/form/DateInput";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import SupplierService from "../../shared/service/SupplierService";
import PurchaseOrderListMobileColumn from "../../shared/component/dataTable/columns/PurchaseOrderListMobileColumn.json";
import Dialog from "../../shared/component/dialog/Dialog";

import PurchaseOrderItemMobileSave from "./PurchaseOrderItemMobileSave";
import {RadioButton} from "primereact/radiobutton";
import {AutoComplete} from "primereact/autocomplete";
import {toast} from "react-toastify";
import ProductService from "../../shared/service/ProductService";
import Loading from "../../shared/component/others/Loading";
import DepartmentService from "../../shared/service/DepartmentService";
import Decimal from "../storemanagement/decimal.mjs";
import {Checkbox} from "primereact/checkbox";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import SupplierFilter from "../storemanagement/SupplierFilter";
import NumberFormat from 'react-number-format';
import CalculationUtils from "../../shared/utils/CalculationUtils";
import MerchantUserService from "../../shared/service/MerchantUserService";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import DataTableAll from "../../shared/component/dataTable/DataTableAll";

dayjs.extend(customParseFormat);

function toBackendLocalDateTime(value) {
    if (GeneralUtils.isNullOrEmpty(value) || value === 'Invalid Date') {
        return null;
    }
    let parsed = dayjs(value, 'DD/MM/YYYY', true);
    if (!parsed.isValid()) {
        parsed = dayjs(value);
    }
    return parsed.isValid() ? parsed.format('YYYY-MM-DDT00:00:00') : null;
}

const defaultLicense = {
    id: null,
    bssId: null,
    invoiceNumber: null,
    deliveryDate: null,
    invoiceDate: null,
    createDate: null,
    purchaseOrderStatus: 'INVOICE',
    invoiceType: "MANUAL_ENTRY",
    itemList: [],

    totalNet: null,
    totalAmount: null,
    totalTax: null,
    discountAmount: null,
    tillPriceCalculationMethod: "NEAREST_9",
    printQueueTillUserBssId: null,

    supplierBssId: null,
    supplierName: null,
    supplierApproved: false,
    includeTax: false,
    useInvoiceBarcode: true,
    readBoxQuantityFromProduct: false,
    supplierAccountCode: null,
    supplierPhoneNumber: null,
    addressLine1: null,
    addressLine2: null,
    addressLine3: null,
    addressLine4: null,
    postcode: null,
    city: null,
    md5sum: null,
    totalFileCount: null,
    processedFileCount: null

};
const defaultItem = {
    id: null,
    bssId: null,

    // fixed
    barcode: null,
    productCode: null,
    generatedProductCode: null,
    itemName: null,
    boxUnitMeasure: null,       // this is not needed, included if needed later
    itemUnitMeasure: null,
    itemSize: null,
    taxRate: null,
    weighable: false,           // default is false

    // variable
    orderQuantity: null,
    deliveryQuantity: null,
    boxSize: null,
    unitPrice: null,
    totalPrice: null,
    taxPrice: null,
    discount: null,
    taxAmount: null,

    // optional / calculated / future fields
    itemBssId: null,
    salePrice: null,
    profitMargin: null,
    expiryDate: null,
    orjDescription: null,
    itemClosed: false,
    barcodeIsSearched: false,
    tillPriceCalculationMethod: null,
    newCodedProduct: false,
    printQueueTillUserBssId: null,
    maxOrjStock: null,
    maxStock: null,
    minStock: null,
    status: 'ACTIVE',
    priceMark: null,
    currentBoxPrice: null,
    currentBoxSize: null,
    currentUnitCost: null  // hesaplanan alan (display only)
};


export default class PurchaseOrderMobileSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            license: Object.assign({}, defaultLicense),
            licenseTemp: Object.assign({}, defaultLicense),
            renderExtraDataDeleteButton: false,
            pageMode: null,
            filteredProducts: [],
            departmentList: [],
            tillUserList: [],
            filterOption: "productUnmatched",
            supplierList: [],
            selectValue: 'Barcode',
            processButton: "process",
            /** true: tablo/satır; false: Process (filtreye göre ilk kalem) akışı */
            itemDialogOpenedFromItem: true,
            loading: false,
            first: 0,
            rows: 10,
            productOpen: false,
            costPricingOpen: true,
            displayDialog: false,
            displayDialogFilter: false,
        }
        this.purchaseOrderService = new PurchaseOrderService();
        this.supplierService = new SupplierService();
        this.productService = new ProductService();
        this.departmentService = new DepartmentService();
        this.merchantUserService = new MerchantUserService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
        this.dialogHistoryPushed = false;
        this.ignoreNextPopState = false;
        this.handlePopState = this.handlePopState.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    refetchLicenseById = (id) => {
        if (GeneralUtils.__isValueEmpty(id) || id === "-1") return;
        this.purchaseOrderService.findById(id).then(response => {
            const responseObject = Object.assign({}, response);
            const responseObjectTemp = Object.assign({}, response);
            this.setState({
                license: responseObject,
                licenseTemp: responseObjectTemp,
                licenseSaveButtonRender: true
            }, () => {
                const approved = this.checkSupplierApproved();
                if (approved) {
                    const allEditButtons = document.querySelectorAll('.p-row-editor-init-icon');
                    if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") {
                        allEditButtons.forEach((btn) => {
                            btn.click();
                        });
                    }
                }
            });
        });
    };

    handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
            const id = window.location.href.split("?")[1];
            if (!GeneralUtils.__isValueEmpty(id) && id !== "-1") {
                this.refetchLicenseById(id);
            }
        }
    };

    componentDidMount() {
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener("popstate", this.handlePopState);
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        window.__purchaseOrderMobileBack = this.handleBackButton;

        this.departmentService.findAll().then(response => this.setState({departmentList: response}));

        this.merchantUserService.getTillUsers(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    tillUserList: response,
                });
            }

        });

        const id = window.location.href.split("?")[1];

        if (!GeneralUtils.__isValueEmpty(id) && id != "-1") {
            this.refetchLicenseById(id);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", this.handlePopState);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        if (window.__purchaseOrderMobileBack === this.handleBackButton) {
            delete window.__purchaseOrderMobileBack;
        }
    }


    renderPurchaseOrder() {

        const allItems = this.state.license.itemList || [];
        const activeItems = allItems.filter(item => item.status === "ACTIVE");
        const duplicateItems = this.getDuplicateItems(activeItems);
        const duplicateItemIds = new Set(
            duplicateItems.map(item =>
                item.id != null ? `id:${item.id}` : `key:${item.barcode || ''}|${item.productCode || ''}`
            )
        );

        const filteredItems = allItems.length
            ? allItems.filter(item => {
                const key =
                    item.id != null ? `id:${item.id}` : `key:${item.barcode || ''}|${item.productCode || ''}`;

                if (this.state.filterOption === 'productUnmatched') {
                    return item.barcodeIsSearched == false || item.barcodeIsSearched == null;
                }
                if (this.state.filterOption === 'priceUnmatched') {
                    return item.oldPrice !== item.salePrice;
                }
                if (this.state.filterOption === 'productNew') {
                    return item.barcodeIsSearched == true && item.itemBssId == null;
                }
                if (this.state.filterOption === 'duplicates') {
                    return duplicateItemIds.has(key);
                }
                return true;
            })
            : [];


        if ((this.state.license.invoiceType == "UPLOAD" && !GeneralUtils.isNullOrEmpty(this.state.license.id)) || this.state.license.invoiceType == "MANUAL_ENTRY" || this.state.license.invoiceType == "CSV") {


            return (
                <div className="mobile-page-content">


                    <Fieldset legend={"Invoice Detail"}
                              toggleable
                              collapsed={!this.state.productOpen}
                              onToggle={this.toggleProduct}
                    >


                        <Row>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="actionReason">
                                        <Translate contentKey="merchantBranch.actionReason">Status</Translate>
                                    </Label>
                                    <AvField
                                        type="select"
                                        className="form-control"
                                        name="purchaseOrderStatus"
                                        disabled={true}
                                        value={this.state.license.purchaseOrderStatus}
                                        onChange={this.__handleChange}>
                                        {PURCHASE_ORDER_STATUS.map(element => (
                                            <option value={element.value} key={element.value}>
                                                {element.name}
                                            </option>
                                        ))}
                                    </AvField>
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="updateDate">
                                        <Translate
                                            contentKey="merchantBranch.updateDate">Invoice Date</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>

                                    <DateInput
                                        name="invoiceDate"
                                        onChange={this.__handleChange}
                                        format={"DD/MM/YYYY"}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                        value={this.state.license.invoiceDate}/>

                                </AvGroup>

                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="remainingDaysText">
                                        <Translate contentKey="merchantBranch.remainingDaysText">Invoice Number
                                        </Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        type="text"
                                        className="form-control"
                                        name="invoiceNumber"
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                        value={this.state.license.invoiceNumber}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </Col>


                        </Row>

                        <Row>

                            {this.renderSupplier()}


                        </Row>


                        <Row>


                            <Col md="3">
                                <AvGroup>
                                    <Label for="totalNet">
                                        <Translate contentKey="merchantBranch.totalNet">Invoice Subtotal</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <NumberFormat
                                        value={this.state.license.totalNet}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        onValueChange={(values) => {
                                            this.setState(prev => ({
                                                license: {...prev.license, totalNet: values.value}
                                            }));
                                        }}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                    />
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="totalAmount">
                                        <Translate contentKey="merchantBranch.totalAmount">Invoice Total</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <NumberFormat
                                        value={this.state.license.totalAmount}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        onValueChange={(values) => {
                                            this.setState(prev => ({
                                                license: {...prev.license, totalAmount: values.value}
                                            }));
                                        }}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                    />
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="itemsTotalPrice">
                                        <Translate contentKey="merchantBranch.itemsTotalPrice">Items Total</Translate>
                                    </Label>
                                    <NumberFormat
                                        value={this.calculateItemsTotalPrice()}
                                        className={`number-format-input ${this.isDifferent(this.state.license) ? "highlight-text" : ""}`}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        disabled={true} // sadece okunur
                                    />
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="totalTax">
                                        <Translate contentKey="merchantBranch.totalTax">Tax Total</Translate>
                                    </Label>
                                    <NumberFormat
                                        value={this.state.license.totalTax}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        onValueChange={(values) => {
                                            this.setState(prev => ({
                                                license: {...prev.license, totalTax: values.value}
                                            }));
                                        }}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                    />
                                </AvGroup>
                            </Col>


                            <Col md="3">
                                <AvGroup>
                                    <Label for="totalProfit">
                                        <Translate contentKey="merchantBranch.totalProfit">Total Profit</Translate>
                                    </Label>
                                    <NumberFormat
                                        value={this.calculateTotalProfit()}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        disabled={true}
                                    />
                                </AvGroup>
                            </Col>

                            <Col md="3">

                                <AvGroup>
                                    <Label for="mobilePhone">
                                        <Translate contentKey="contactManagement.mobilePhone">Invoice Till User
                                        </Translate>
                                    </Label>

                                    <AvField
                                        type="select"
                                        disabled={!(this.state.licenseSaveButtonRender && !GeneralUtils.isNullOrEmpty(this.state.license.id) && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                        className="form-control"
                                        name="printQueueTillUserBssId"
                                        value={this.state.license.printQueueTillUserBssId}
                                        onChange={this.__handleChange}>

                                        <option value="" key=''>
                                            Select
                                        </option>
                                        {this.state.tillUserList.map(element => (
                                            <option value={element.bssId} key={element.bssId}>
                                                {element.name}
                                            </option>))}
                                    </AvField>

                                </AvGroup>
                            </Col>


                        </Row>


                    </Fieldset>

                    <Fieldset legend={"Items"}
                              toggleable
                              collapsed={!this.state.costPricingOpen}
                              onToggle={this.toggleCostPricing}

                    >

                        <Dialog
                            visible={this.state.displayDialog}
                            onHide={this.closeDisplayDialog}
                            className="full-screen-dialog"
                            appendTo={document.body}
                            modal={true}
                            draggable={false}
                            resizable={false}

                        >

                            <PurchaseOrderItemMobileSave ref={(elem) => this.refModelSave = elem}
                                                         refreshDataTable={this.refreshDataTable}
                                                         calculateFields={this.calculateFields}
                                                         deleteItemData={this.deleteItemData}
                                                         openNextItem={this.openNextItem}
                                                         updatePurchaseOrderItem={this.updatePurchaseOrderItem}
                                                         updatePurchaseOrderItemFieldsOnly={this.updatePurchaseOrderItemFieldsOnly}
                                                         updatePurchaseOrderItemAndNext={this.updatePurchaseOrderItemAndNext}
                                                         updatePurchaseOrderItemAndNextUnmatched={this.updatePurchaseOrderItemAndNextUnmatched}
                                                         closePurchaseOrderItemAndNext={this.closePurchaseOrderItemAndNext}
                                                         closePurchaseOrderItemAndNextUnmatched={this.closePurchaseOrderItemAndNextUnmatched}
                                                         closeDisplayDialog={this.closeDisplayDialog}
                                                         refreshOrderAndClose={this.refreshOrderAndClose}/>
                        </Dialog>


                        {this.renderSelectItems()}

                        {this.renderFilter()}

                        <DataTableAll data={filteredItems}
                                      ref={(elem) => this.refDataTable = elem}
                                      selectionMode='single'
                                      paginator={true}
                                      rows={50}
                                      first={this.state.first}
                                      onDataSelect={this.onDataSelect}
                                      setStateData={this.setStateData}
                                      calculateFields={this.calculateFields}
                                      checkSupplierApproved={this.checkSupplierApproved}
                                      fields={PurchaseOrderListMobileColumn.fields}
                                      rowClassName={(rowData) => (rowData.shouldWarnUser === true ? { highlightTableRowLightRed: true } : {})}
                        />


                    </Fieldset>


                    {this.renderButtons()}
                </div>
            )

        }
    };

    renderButtons() {
        return (
            <div className="mobile-fixed-footer">
                <div className="mobile-fixed-footer-inner">

                    {this.state.license.purchaseOrderStatus != "CLOSED" && !this.state.licenseSaveButtonRender &&
                        <Button
                            color="outline-primary"
                            style={{marginRight: '5px', height: '30px', width: '110px'}}
                            onClick={() => {

                                this.setState({
                                    licenseSaveButtonRender: true
                                }, () => {
                                    this.setAllRowsEditable();
                                });

                            }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>
                    }

                    {this.state.licenseSaveButtonRender &&
                        <Button
                            color="outline-primary"
                            style={{marginRight: '5px', marginTop: '5px', height: '30px', width: '110px'}}
                            onClick={() => {
                                const approved = this.checkSupplierApproved();
                                if (approved) {
                                    this.savePurchaseOrderItem(false);
                                } else {
                                    return toast.warn("Please approve supplier to continue");
                                }
                            }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>
                    }

                    {!GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                        this.state.license.purchaseOrderStatus !== "CLOSED" &&
                        (() => {
                            const itemList = this.state.license.itemList || [];

                            const hasActiveItem = itemList.some(item => item.status === "ACTIVE");

                            if (!hasActiveItem) return null;

                            return (
                                <Button
                                    color="outline-primary"
                                    style={{
                                        marginRight: '5px',
                                        height: '30px',
                                        width: '110px',
                                        marginTop: '5px',
                                    }}
                                    onClick={this.openFirstItemByFilter}
                                >
                                    Process
                                </Button>
                            );
                        })()
                    }

                    <Button
                        color="outline-primary"
                        style={{marginRight: '5px', marginTop: '5px', height: '30px', width: '110px'}}
                        onClick={() => {
                            let obj1 = Object.assign({}, defaultLicense);
                            obj1.itemList = [];

                            this.setState({
                                license: obj1,
                                licenseTemp: Object.assign({}, obj1)
                            }, () => {
                                if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
                                    sessionStorage.setItem("purchaseOrderMobile.filterOption", "Invoice");
                                    sessionStorage.setItem("purchaseOrderMobile.selectedInvoiceId", this.state.license.id);
                                }
                                sessionStorage.setItem("purchaseOrderMobile.skipRedirectToSave", "true");
                                window.location.href = "#purchaseOrderMobile";
                            });

                        }}>
                        <Translate contentKey="entity.action.cancel">Back</Translate>
                    </Button>

                </div>
            </div>
        );
    }


    openFirstItemByFilter = () => {
        const {license, filterOption} = this.state;
        const itemList = license.itemList || [];

        if (!this.checkSupplierApproved()) {
            toast.warn("Please approve supplier to continue");
            return;
        }

        let firstItem = null;

        if (filterOption === "productNew") {
            firstItem = itemList.find(
                item =>
                    item.barcodeIsSearched === true &&
                    item.itemBssId == null &&
                    item.status === "ACTIVE"
            );
        } else if (filterOption === "productUnmatched") {
            firstItem = itemList.find(
                item =>
                    (!item.barcodeIsSearched || item.barcodeIsSearched == null) &&
                    item.status === "ACTIVE"
            );
        } else if (filterOption === "all") {
            firstItem = itemList.find(item => item.status === "ACTIVE");
        }

        if (firstItem) {
            this.onDataSelect(firstItem, false);
        } else {
            toast.info("No items found.");
        }
    };


    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip sıradaki item'a geçer. Yeni item (id yok) ise PO listeyle kaydedilir ve dialog kapanır. */
    updateAndSelectNextByFilter = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const { license, filterOption } = this.state;
        const licenseId = license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                const activeItems = freshLicense.itemList || [];
                const existingIndex = activeItems.findIndex(item => item.id === data.id);
                const idx = existingIndex >= 0 ? existingIndex : activeItems.findIndex(item => item.barcode === data.barcode);
                let nextItem = null;
                switch (filterOption) {
                    case "productNew":
                        nextItem = activeItems
                            .slice(idx + 1)
                            .find(item => item.barcodeIsSearched && item.itemBssId == null);
                        break;
                    case "productUnmatched":
                        nextItem = activeItems
                            .slice(idx + 1)
                            .find(item => !item.barcodeIsSearched || item.barcodeIsSearched == null);
                        break;
                    case "all":
                    default:
                        nextItem = activeItems[idx + 1];
                        break;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense),
                    licenseSaveButtonRender: true
                }, () => {
                    if (nextItem) {
                        this.onDataSelect(nextItem, false);
                    } else {
                        this.closeDisplayDialog();
                    }
                });
            })
            .catch(() => {});
    };


    checkSupplierApproved = () => {
        const {invoiceType, supplierApproved, supplierId} = this.state.license;
        //return !(invoiceType === "UPLOAD" && supplierApproved === false && supplierId == null);
        return !(invoiceType === "UPLOAD" && supplierApproved === false);
    };

    setAllRowsEditable = () => {
        try {
            const approved = this.checkSupplierApproved();
            if (approved) {
                const allEditButtons = document.querySelectorAll('.p-row-editor-init-icon');
                if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") {
                    allEditButtons.forEach((btn) => {
                        btn.click();
                    });
                }


            } else {
                return toast.warn("Please approve supplier to continue");
            }


        } catch (e) {

        }


    };


    renderFilter() {
        const isMobile = GeneralUtils.isMobile();

        const license = this.state.license || {};
        const items = Array.isArray(license.itemList) ? license.itemList : [];
        const activeItems = items.filter(item => item.status === "ACTIVE");
        const duplicatesCount = this.getDuplicateItems(activeItems).length;

        return (
            <div
                style={{
                    display: 'flex',
                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                    gap: '16px',
                    alignItems: 'center',
                    marginBottom: '12px',
                    width: '100%',
                }}
            >
                <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                    <RadioButton
                        inputId="all"
                        name="filter"
                        value="all"
                        onChange={this.handleFilterChange}
                        checked={this.state.filterOption === "all"}
                    />
                    <label htmlFor="all">All</label>
                </div>

                <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                    <RadioButton
                        inputId="productUnmatched"
                        name="filter"
                        value="productUnmatched"
                        onChange={this.handleFilterChange}
                        checked={this.state.filterOption === "productUnmatched"}
                    />
                    <label htmlFor="productUnmatched">Pending</label>
                </div>

                <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                    <RadioButton
                        inputId="productNew"
                        name="filter"
                        value="productNew"
                        onChange={this.handleFilterChange}
                        checked={this.state.filterOption === "productNew"}
                    />
                    <label htmlFor="productNew">New</label>
                </div>

                <div style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                    <RadioButton
                        inputId="duplicates"
                        name="filter"
                        value="duplicates"
                        onChange={this.handleFilterChange}
                        checked={this.state.filterOption === "duplicates"}
                    />
                    <label
                        htmlFor="duplicates"
                        style={{
                            color: duplicatesCount > 0 ? '#DC2626' : undefined,
                            fontWeight: 500
                        }}
                    >
                        Duplicates
                    </label>
                </div>

                {/* + butonu sağa yaslı */}
                <div style={{marginLeft: 'auto', display: 'flex', alignItems: 'center'}}>
                    {this.state.license.purchaseOrderStatus !== "CLOSED" &&
                        this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED" &&
                        !GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                        this.checkSupplierApproved() && (
                            <Button
                                style={{
                                    height: '30px',
                                    width: '30px',
                                    padding: 0,
                                    border: 'none',
                                    boxShadow: 'none',
                                    background: 'transparent',
                                    display: 'flex',
                                    alignItems: 'right',
                                    justifyContent: 'right'
                                }}
                                onClick={() => {
                                    const newItem = Object.assign({}, defaultItem);
                                    newItem.tillPriceCalculationMethod = 'MANUAL_ENTRY';
                                    this.onDataSelect(newItem, false);
                                }}
                            >
                                <i className="pi pi-plus" style={{fontSize: '30px', color: '#1982D9'}}/>
                            </Button>
                        )}
                </div>
            </div>
        );
    }


    handleFilterChange = (e) => {
        this.setState({filterOption: e.value}, () => {
        });
    };


    renderSelectItems() {
        if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.invoiceType == "MANUAL_ENTRY") {
            return (<div class="p-col-12">

                <Fieldset legend="Select Product">


                    <Row>
                        <Col md={2}>


                            <div className="flex align-items-center">
                                <RadioButton disabled={!this.state.licenseSaveButtonRender} inputId="ingredient1"
                                             value="Barcode" onChange={(e) => {
                                    this.setState({
                                        selectValue: e.value,
                                    });


                                }} checked={this.state.selectValue === 'Barcode'}/>
                                <label htmlFor="ingredient1" className="ml-2">Barcode</label>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="flex align-items-center">
                                <RadioButton disabled={!this.state.licenseSaveButtonRender} inputId="ingredient2"
                                             value="Name" onChange={(e) => {
                                    this.setState({
                                        selectValue: e.value,
                                    });


                                }} checked={this.state.selectValue === 'Name'}/>
                                <label htmlFor="ingredient2" className="ml-2">Name</label>
                            </div>
                        </Col>
                    </Row>


                    <Row>
                        <Col md={6}>

                            <Row>
                                {this.state.selectValue === "Barcode" &&
                                    <Col md="6">
                                        <AvGroup>
                                            <Label for="tradingName">
                                                <Translate contentKey="productGroup.tradingName">Barcode</Translate>
                                            </Label>
                                            <AvField
                                                type="number"
                                                name="barcode"
                                                className="form-control"
                                                disabled={!this.state.licenseSaveButtonRender}
                                                max="99999999999999"
                                                onKeyDown={this._handleKeyDown}
                                                value={this.state.barcode}
                                                onChange={this.__handleChangeBarcode}/>
                                        </AvGroup>
                                    </Col>
                                }
                                {this.state.selectValue === "Name" &&
                                    <Col md="6">
                                        <AvGroup>
                                            <Label for="tradingName">
                                                <Translate contentKey="productGroup.tradingName">Name</Translate>
                                            </Label>
                                            <AutoComplete value={this.state.selectedProduct}
                                                          suggestions={this.state.filteredProducts}
                                                          completeMethod={this.searchProduct}
                                                          onBlur={() => {
                                                              setTimeout(() => {
                                                                  this.setState({filteredProducts: []});
                                                              }, 200);
                                                          }}
                                                          field="longname"
                                                          disabled={!this.state.licenseSaveButtonRender}
                                                          onChange={async (e) => {
                                                              let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                                                              this.setState({selectedProduct: value});
                                                              if (!GeneralUtils.isNullOrEmpty(e.value?.id)) {
                                                                  const data = await this.convertToDto(e.value);
                                                                  this.updatePurchaseOrderItem(data);
                                                              }
                                                          }}

                                            />
                                        </AvGroup>
                                    </Col>
                                }
                            </Row>


                        </Col>

                    </Row>


                </Fieldset>

            </div>)
        }
    };


    onDataSelect = (data, isOpenFromItem) => {
        if (isOpenFromItem === undefined || isOpenFromItem === null) {
            isOpenFromItem = true;
        }
        const approved = this.checkSupplierApproved();

        if (approved) {
            this.pushDialogHistory();
            GeneralUtils.openDialogThenRef(this, {
                displayDialog: true,
                itemDialogOpenedFromItem: isOpenFromItem
            }, () => this.refModelSave, (ref) => {
                ref.setData(data, this.state.license.purchaseOrderStatus, this.state.license.invoiceType, isOpenFromItem, this.state.license.tillPriceCalculationMethod, this.state.license.printQueueTillUserBssId);
            });
        } else {
            return toast.warn("Please approve supplier to continue");
        }


    }

    __handleChangeBarcode = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({barcode: value});
    }

    /**
     * License'ı servise kaydeder. Promise döner; sadece başarılı yanıtta resolve olur.
     * Böylece state/dialog sadece servis başarılı olduğunda güncellenir, kullanıcı hata durumunda bilgilendirilir.
     * @param {Object} license - Kaydedilecek license objesi (state'ten veya güncellenmiş kopya)
     * @param {boolean} licenseSaveButtonRender
     * @returns {Promise} - Başarıda response ile resolve, hata/validasyon fail'de reject
     */
    saveLicenseToServer = (license, licenseSaveButtonRender) => {
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.invoiceNumber)) {
            toast.warn("Invoice Number is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.supplierName)) {
            toast.warn("Supplier is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.invoiceDate)) {
            toast.warn("Invoice Date is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.totalNet)) {
            toast.warn("Invoice Subtotal is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && license.totalAmount == null) {
            toast.warn("Invoice Total is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType == "CSV" && (GeneralUtils.isNullOrEmpty(license.invoiceNumber) || GeneralUtils.isNullOrEmpty(license.supplierName))) {
            toast.warn("Please fill the Invoice Number and Supplier fields!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.purchaseOrderStatus == "CLOSED" && (!license.itemList || license.itemList.length == 0)) {
            toast.warn("Please add item!");
            return Promise.reject(new Error("VALIDATION"));
        }

        const licenseToSave = { ...license };
        licenseToSave.deliveryDate = toBackendLocalDateTime(licenseToSave.deliveryDate);
        licenseToSave.invoiceDate = toBackendLocalDateTime(licenseToSave.invoiceDate);

        const apiCall = !GeneralUtils.isNullOrEmpty(licenseToSave.id)
            ? this.purchaseOrderService.update(licenseToSave)
            : this.purchaseOrderService.create(licenseToSave);

        return apiCall
            .then((response) => {
                if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                    return Promise.reject(new Error("INVALID_RESPONSE"));
                }
                if (response.purchaseOrderStatus == "CLOSED") {
                    window.location.href = "#purchaseOrder";
                    return response;
                }
                this.setState({
                    licenseSaveButtonRender: licenseSaveButtonRender,
                    license: Object.assign({}, response),
                    licenseTemp: Object.assign({}, response)
                });
                return response;
            })
            .catch((err) => {
                toast.error("The request could not be sent to the server. Please try again.");
                return Promise.reject(err);
            });
    };

    savePurchaseOrderItem(licenseSaveButtonRender) {
        this.saveLicenseToServer(this.state.license, licenseSaveButtonRender).catch(() => {});
    }


    render() {
        return (<div>
            <AvForm autocomplete="off">
                {this.renderPurchaseOrder()}
            </AvForm>

            {this.state.loading && <Loading label="Processing, please wait..."/>}

        </div>);
    }

    setChecked = (name, value) => {
        let license = {...this.state.license}; // kopya al
        license[name] = value;

        this.setState({license}, () => {
            const updatedItemList = (this.state.license.itemList || []).map(item =>
                this.calculateFields({...item})
            );

            // hesaplanan listeyi tekrar state'e yaz
            this.setState(prevState => ({
                license: {
                    ...prevState.license,
                    itemList: updatedItemList
                }
            }));
        });


    };

    getActiveItems = (license = this.state.license) => {
        const items = Array.isArray(license?.itemList) ? license.itemList : [];
        return items.filter(item => item.status === "ACTIVE");
    };

    /**
     * Aynı barcode'a sahip fakat farklı productCode'ları olan tüm item'ları döner.
     * Mobil ekrandaki filtre ve ileride eklenecek aksiyonlar için kullanılacak.
     */
    getDuplicateItems = (itemList) => {
        const safeList = Array.isArray(itemList) ? itemList : [];
        const barcodeToProductCodes = new Map();
        const barcodeToItems = new Map();

        safeList.forEach(item => {
            if (!item || !item.barcode || !item.productCode) {
                return;
            }
            const barcode = item.barcode;
            const productCode = item.productCode;

            if (!barcodeToProductCodes.has(barcode)) {
                barcodeToProductCodes.set(barcode, new Set());
            }
            if (!barcodeToItems.has(barcode)) {
                barcodeToItems.set(barcode, []);
            }

            barcodeToProductCodes.get(barcode).add(productCode);
            barcodeToItems.get(barcode).push(item);
        });

        const duplicates = [];
        barcodeToProductCodes.forEach((productCodes, barcode) => {
            if (productCodes.size > 1) {
                const itemsForBarcode = barcodeToItems.get(barcode) || [];
                duplicates.push(...itemsForBarcode);
            }
        });

        return duplicates;
    };

    calculateItemsTotalPrice = (license = this.state.license) => {
        const itemList = Array.isArray(license?.itemList) ? license.itemList : [];
        return itemList.reduce((sum, item) => sum + (parseFloat(item.totalPrice) || 0), 0);
    };

    calculateTotalProfit = (license = this.state.license) => {
        return this.getActiveItems(license)
            .reduce((sum, item) => {
                const boxSize = parseFloat(item.boxSize) || 1;
                const deliveryQty = parseFloat(item.deliveryQuantity) || 1;
                const unitCost = parseFloat(item.unitCost) || 0;
                const salePrice = parseFloat(item.salePrice) || 0;
                const profitPerUnit = salePrice - unitCost;
                return sum + (profitPerUnit * deliveryQty * boxSize);
            }, 0);
    };

    isDifferent() {
        let license = this.state.license;
        const licenseAmount = new Decimal(license?.totalAmount || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const licenseNet = new Decimal(license?.totalNet || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const itemsTotal = new Decimal(this.calculateItemsTotalPrice(license) || 0)
            .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

        if (license?.includeTax) {
            return !itemsTotal.equals(licenseAmount);
        } else {
            return !itemsTotal.equals(licenseNet);
        }
    }


    setStateData = (data) => {
        const license = this.state.license;
        const existingList = Array.isArray(license.itemList) ? [...license.itemList] : [];
        const updatedList = Array.isArray(data) ? data : [];

        const isSameItem = (left, right) => {
            if (!left || !right) return false;
            if (left.id != null && right.id != null) {
                return left.id === right.id;
            }
            if (left.barcode && right.barcode) {
                return left.barcode === right.barcode;
            }
            return false;
        };

        const mergedList = existingList.map((item) => {
            const updatedItem = updatedList.find((candidate) => isSameItem(item, candidate));
            return updatedItem ? {...item, ...updatedItem} : item;
        });

        updatedList.forEach((item) => {
            const exists = mergedList.some((candidate) => isSameItem(candidate, item));
            if (!exists) {
                mergedList.push(item);
            }
        });

        this.setState({
            license: {
                ...license,
                itemList: mergedList
            }
        });


    }


    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }


    deleteItemData = () => {
        const {license} = this.state;

        if (license.purchaseOrderStatus !== "CLOSED") {
            const deleteId = this.refModelSave.getDeleteId();
            if (!deleteId) return;

            const updatedItemList = license.itemList.filter(item => item.id !== deleteId);
            const updatedLicense = { ...license, itemList: updatedItemList };

            this.saveLicenseToServer(updatedLicense, true)
                .then(() => this.closeDisplayDialog())
                .catch(() => {});
        }
    }


    convertToDto = async (response) => {
        const data = {
            itemBssId: response.bssId,
            barcode: response.barcode,
            itemName: response.name,
            itemSize: response.quantity,
            taxRate: response.taxRate ?? response.departmentTaxRate,
            weighable: response.weighable,
            deliveryQuantity: 1,
            boxPrice: response.costPrice,
            oldPrice: response.price,
            currentBoxPrice: response.costPrice,
            currentBoxSize: (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null,
            status: "ACTIVE",
            barcodeType: response.barcodeType,
            barcodeDigit: response.barcodeDigit,
            codeLength: response.codeLength,
            salePrice: null,
            profitMargin: response.profitMargin,
            recommendedSalePrice: response.recommendedSalePrice,
            itemUnitMeasure: response.unit,
            boxUnitMeasure: response.boxUnit,
            departmentId: response.departmentId,
            barcodeIsSearched: true,
            tillPriceCalculationMethod: this.state.license.tillPriceCalculationMethod
        };

        // boxSize sadece 0 veya 1 değilse ata
        if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
            data.boxSize = response.boxQuantity;
        } else if (data.boxSize == null && response.boxQuantity != null) {
            data.boxSize = response.boxQuantity;
        }

        // minStock
        if (response.minStock != null && response.minStock !== 0) {
            data.minStock = response.minStock;
        } else {
            data.minStock = await this.getDefaultMinStock();
        }

        // maxStock
        if (response.maxStock != null && response.maxStock !== 0) {
            data.maxStock = response.maxStock;
            data.maxOrjStock = response.maxStock;
        }

        return data;
    };


    convertProductDTOToItemDto = async (data, response) => {
        data.itemBssId = response.bssId;
        data.departmentId = response.departmentId;
        data.taxRate = (response.taxRate ?? response.departmentTaxRate);
        data.oldPrice = response.price;
        data.currentBoxPrice = response.costPrice;
        data.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
        data.status = "ACTIVE";
        data.barcodeType = response.barcodeType;
        data.barcodeDigit = response.barcodeDigit;
        data.codeLength = response.codeLength;
        data.itemName = response.name;
        data.itemSize = response.quantity;
        data.itemUnitMeasure = response.unit;
        // boxSize sadece 0 veya 1 değilse ata
        if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
            data.boxSize = response.boxQuantity;
        } else if (data.boxSize == null && response.boxQuantity != null) {
            data.boxSize = response.boxQuantity;
        }

        data.boxUnitMeasure = response.boxUnit;

        data.profitMargin = (response.profitMargin != null && response.profitMargin !== 0 && response.profitMargin !== 40)
            ? response.profitMargin
            : ((response.departmentProfitMargin != null && response.departmentProfitMargin !== 0 && response.departmentProfitMargin !== 40)
                ? response.departmentProfitMargin
                : await this.getDefaultProfitMargin());
        data.weighable = response.weighable;
        if (response.minStock != null && response.minStock !== 0) {
            data.minStock = response.minStock;
        } else {
            data.minStock = await this.getDefaultMinStock();
        }

        if (response.maxStock != null && response.maxStock !== 0) {
            data.maxStock = response.maxStock;
            data.maxOrjStock = response.maxStock;
        } else {
            data.maxOrjStock = null;
        }

        data.barcodeIsSearched = true;


        return data;


    }

    getDefaultProfitMargin = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.profitMargin?? 40;
                }
                return 40;
            });
    };

    getDefaultMinStock = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.minStock ?? null; // response.minStock varsa al, yoksa null
                }
                return null;
            });
    };
    /** Listeyi güncelle - save/close yapmadan (barcode search sonrası sync için) */
    updatePurchaseOrderItemFieldsOnly = (data) => {
        let license = this.state.license;
        const updatedItemList = [...(license['itemList'] || [])];
        let existingIndex = updatedItemList.findIndex(item => item.id === data.id);
        if (existingIndex == -1) {
            existingIndex = updatedItemList.findIndex(item => item.barcode === data.barcode);
        }
        if (existingIndex !== -1) {
            updatedItemList[existingIndex] = {...updatedItemList[existingIndex], ...data};
        }
        this.setState({ license: { ...license, itemList: updatedItemList } });
    };

    /** Yeni item (id yok): license itemList'e ekleyip PO'yu create/update ile kaydeder, dialog kapatılır. */
    saveNewItemAndClose = (itemData) => {
        const license = this.state.license;
        const updatedItemList = [...(license.itemList || [])];
        updatedItemList.push({...itemData, status: itemData.status || 'ACTIVE', shouldWarnUser: itemData.shouldWarnUser === true});
        const updatedLicense = {...license, itemList: updatedItemList};
        this.saveLicenseToServer(updatedLicense, true)
            .then(() => this.closeDisplayDialog())
            .catch(() => {});
    };

    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip ekranda son hali gösterilir. */
    updatePurchaseOrderItem = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const licenseId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense),
                    licenseSaveButtonRender: true
                }, () => this.closeDisplayDialog());
            })
            .catch(() => {});
    }

    closePurchaseOrderItemAndNextUnmatched = (data) => {
        if (this.state.processButton == "new") {
            let license = this.state.license;
            const updatedItemList = license['itemList'];

            const activeItems = updatedItemList;

            // 🔹 id veya barcode ile aktif listede mevcut item'ı bul
            let existingIndex = activeItems.findIndex(item => item.id === data.id);
            if (existingIndex === -1) {
                existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
            }

            if (existingIndex !== -1) {
                const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
                updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
            } else {
                updatedItemList.push(data);
            }

            license['itemList'] = updatedItemList;

            this.setState({license}, () => {

                // sıradaki aktif item’lerden barcodeIsSearched == true && itemBssId == null olanı bul
                const nextNew = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === true && item.itemBssId == null);

                if (nextNew) {
                    this.onDataSelect(nextNew, false);
                } else {
                    this.closeDisplayDialog();
                }
            });
        } else {
            let license = this.state.license;
            const updatedItemList = license['itemList'];
            const activeItems = updatedItemList;

            let existingIndex = activeItems.findIndex(item => item.id === data.id);
            if (existingIndex === -1) {
                existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
            }

            if (existingIndex !== -1) {
                const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
                updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
            } else {
                updatedItemList.push(data);
            }

            license['itemList'] = updatedItemList;

            this.setState({license}, () => {

                const nextUnmatched = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === false || item.barcodeIsSearched == null);

                if (nextUnmatched) {
                    this.onDataSelect(nextUnmatched, false);
                } else {
                    this.closeDisplayDialog();
                }
            });
        }
    };

    openNextItem = (data) => {
        let license = this.state.license;
        const updatedItemList = license['itemList'];
        const activeItems = updatedItemList;
        const { filterOption, itemDialogOpenedFromItem } = this.state;

        let existingIndex = activeItems.findIndex(item => item.id === data.id);

        if (existingIndex !== -1) {
            const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
            updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
        } else {
            updatedItemList.push(data);
        }

        license['itemList'] = updatedItemList;

        this.setState({license}, () => {

            if (itemDialogOpenedFromItem) {
                const nextIndex = existingIndex + 1;
                if (nextIndex < activeItems.length) {
                    this.onDataSelect(activeItems[nextIndex], true);
                } else {
                    this.closeDisplayDialog();
                }
                return;
            }

            const rest = activeItems.slice(existingIndex + 1);
            let nextRow = null;
            switch (filterOption) {
                case "productNew":
                    nextRow = rest.find(item => item.barcodeIsSearched && item.itemBssId == null);
                    break;
                case "productUnmatched":
                    nextRow = rest.find(item => !item.barcodeIsSearched || item.barcodeIsSearched == null);
                    break;
                case "all":
                default:
                    nextRow = activeItems[existingIndex + 1];
                    break;
            }

            if (nextRow) {
                this.onDataSelect(nextRow, false);
            } else {
                this.closeDisplayDialog();
            }
        });
    };

    closePurchaseOrderItemAndNext = (data) => {
        let license = this.state.license;
        const updatedItemList = license['itemList'];

        const activeItems = updatedItemList;

        // 🔹 id veya barcode ile aktif listede mevcut item'ı bul
        let existingIndex = activeItems.findIndex(item => item.id === data.id);
        if (existingIndex === -1) {
            existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
        }

        if (existingIndex !== -1) {
            const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
            updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
        } else {
            updatedItemList.push(data);
        }

        license['itemList'] = updatedItemList;

        this.setState({license}, () => {

            const nextIndex = existingIndex + 1;
            if (nextIndex < activeItems.length) {
                this.onDataSelect(activeItems[nextIndex], true);
            } else {
                this.closeDisplayDialog();
            }
        });
    };

    updatePurchaseOrderItemAndNext = (data) => {
        this.updateAndSelectNextByFilter(data);
    };

    updatePurchaseOrderItemAndNextUnmatched = (data) => {
        this.updateAndSelectNextByFilter(data);
    };


    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
        this.popDialogHistory();
    }

    /** Sadece order'ı DB'den çekip listeyi günceller ve dialog'u kapatır (conflict'te başka item seçildiğinde revert'i ezmemek için). */
    refreshOrderAndClose = () => {
        const licenseId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            this.closeDisplayDialog();
            return;
        }
        this.purchaseOrderService.findById(licenseId)
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    this.closeDisplayDialog();
                    return;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense),
                    licenseSaveButtonRender: true
                }, () => this.closeDisplayDialog());
            })
            .catch(() => this.closeDisplayDialog());
    }


    licenseSaveButtonRender = () => {
        this.setState({licenseSaveButtonRender: true});
    }

    setData = (data) => {
        this.setState({
            license: data,
            licenseTemp: Object.assign({}, data),
            licenseSaveButtonRender: false,
            renderExtraDataDeleteButton: false
        });

    }


    clearData = () => {
        let obj = Object.assign({}, defaultLicense);
        this.setState({license: obj, renderExtraDataDeleteButton: false});
    }


    __handleChange = (e) => {
        const {name, value: rawValue, parsedValue} = e.target;
        const value = parsedValue !== undefined ? parsedValue : rawValue;

        if (name == "tillPriceCalculationMethod") {
            let license = {...this.state.license}; // kopya al
            license[name] = value;

            this.setState({license}, () => {
                const updatedItemList = (license.itemList || []).map(item => {
                    // item = { ...item, tillPriceCalculationMethod: value };
                    return this.calculateFields(item);
                });

                this.setState(prevState => ({
                    license: {
                        ...prevState.license,
                        itemList: updatedItemList
                    }
                }));
            });
        } else {
            this.setState(prev => {
                let updatedLicense = {
                    ...prev.license,
                    [name]: value,
                    ...(name === "barcode"
                        ? {
                            barcodeIsSearched: false,
                            ItemBssId: null
                        }
                        : {})

                };

                return {license: updatedLicense};
            });
        }
    };


    __handleChangeStatus = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let license = this.state.license;
        license[e.target.name] = value;
        this.setState({license: license});
    }
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.findByBarcode();
        }
    }

    searchProduct = (event) => {
        setTimeout(() => {
            this.productService.searchProductsByName(event.query).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({filteredProducts: response});
                } else {
                    this.setState({filteredProducts: []});
                }


            });
        }, 250);
    }

    findByBarcode() {
        if (!GeneralUtils.isNullOrEmpty(this.state.barcode)) {
            this.productService.findProductByBarcodeWithDepos(this.state.barcode)
                .then(async (response) => {

                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.refreshDepartmentListIfMissing(response.departmentId);
                        const data = await this.convertToDto(response);
                        this.updatePurchaseOrderItem(data);
                    } else {
                        this.setState({
                            barcode: '', selectedProduct: null, productId: null, productList: []
                        });
                        this.setState({}, () => {
                            //return toast.warn("Barcode not Found!");
                        });
                    }
                });
        }
        this.setState({barcode: ''});

    }

    refreshDepartmentListIfMissing = (departmentId) => {
        if (GeneralUtils.isNullOrEmpty(departmentId)) {
            return;
        }
        const exists = (this.state.departmentList || []).some((department) => department.id === departmentId);
        if (!exists) {
            this.departmentService.findAll().then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({departmentList: response});
                }
            });
        }
    }

    renderSupplier() {
        return (
            <>
                <Col md="3">
                    <AvGroup>
                        <Label for="tradingName">
                            <Translate contentKey="productGroup.tradingName">Supplier</Translate>
                            <span style={{color: 'red'}}> (*)</span>
                        </Label>

                        <div style={{position: "relative"}}>
                            {/* Input */}
                            <AvField
                                type="text"
                                name="supplierName"
                                className="form-control"
                                style={{paddingRight: "90px"}} // ikonlar için sağ boşluk
                                disabled={this.state.license.invoiceType == "MANUAL_ENTRY" || this.state.license.invoiceType == "CSV" ? true : !this.state.licenseSaveButtonRender || this.state.license.supplierApproved || !GeneralUtils.isNullOrEmpty(this.state.license.supplierId)}
                                value={this.state.license.supplierName}
                                onChange={this.__handleChange}
                            />

                            {/* Iconlar */}
                            <div
                                style={{
                                    position: "absolute",
                                    right: "2px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    display: "flex",
                                    gap: "2px",
                                }}
                            >
                                {/* Search Icon */}
                                {!(!this.state.licenseSaveButtonRender || this.state.license.supplierApproved || !GeneralUtils.isNullOrEmpty(this.state.license.supplierId)) &&
                                    <i
                                        className="pi pi-search"
                                        style={{
                                            cursor: this.state.licenseSaveButtonRender ? "pointer" : "not-allowed",
                                            color: this.state.licenseSaveButtonRender ? "#000" : "#ccc",
                                        }}
                                        onClick={() => {
                                            if (!this.state.licenseSaveButtonRender) return;
                                            this.pushDialogHistory();
                                            this.setState({displayDialogFilter: true});
                                        }}
                                    />
                                }


                                {/* Matched / Not Matched */}
                                {!GeneralUtils.isNullOrEmpty(this.state.license.supplierId) ? (
                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            padding: "2px 6px",
                                            borderRadius: "6px",
                                            backgroundColor: "#16A34A",
                                            color: "white",
                                            fontWeight: 600,
                                            fontSize: "12px",
                                        }}
                                    >
                                            <i className="pi pi-check" style={{cursor: "pointer", color: "white"}}/>
                                          </span>
                                ) : (
                                    <span
                                        className="blinking-badge"
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            padding: "2px 6px",
                                            borderRadius: "6px",
                                            backgroundColor: "#DC2626",
                                            color: "white",
                                            fontWeight: 600,
                                            fontSize: "12px",
                                        }}
                                    >

                                        <span>NEW</span>
                                      </span>
                                )}

                            </div>


                        </div>

                        {this.state.license.purchaseOrderStatus != "CLOSED" &&

                            !this.checkSupplierApproved() &&
                            <Button
                                color="outline-primary"
                                style={{marginRight: '5px', height: '30px', width: '180px'}}
                                onClick={() => {
                                    let license = this.state.license;

                                    if (GeneralUtils.isNullOrEmpty(license.supplierName)
                                    ) {
                                        return toast.warn("Please fill the supplier field!");
                                    } else {
                                        this.purchaseOrderService.approveSupplierAndProcessAgain(license)
                                            .then((response) => {
                                                if (
                                                    !GeneralUtils.isNullOrEmpty(response) &&
                                                    GeneralUtils.isNullOrEmpty(response.type)
                                                ) {
                                                    this.setState({
                                                        license: response,
                                                        licenseTemp: response
                                                    }, () => {
                                                        this.setAllRowsEditable();
                                                    });
                                                }
                                            });
                                    }

                                }}
                            >
                                <Translate contentKey="entity.action.add">Approve Supplier</Translate>
                            </Button>
                        }
                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="firstName">
                            <Translate contentKey="productfirstName">
                                Invoice Till Price Calculator
                            </Translate>
                        </Label>

                        <AvField
                            type="select"
                            className="form-control"
                            name="tillPriceCalculationMethod"
                            disabled={
                                !(
                                    this.state.licenseSaveButtonRender &&
                                    this.state.license.purchaseOrderStatus !== "CLOSED" &&
                                    this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED"
                                )
                            }
                            value={this.state.license.tillPriceCalculationMethod || "NEAREST_9"}
                            onChange={this.__handleChange}
                        >
                            {TILL_PRICE_CALCULATION_METHOD.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>
                            ))}
                        </AvField>


                    </AvGroup>
                </Col>


                <Col md="3">
                    <AvGroup>
                        <Label for="firstName">
                            <Translate contentKey="productfirstName">Inc VAT&nbsp;</Translate>
                        </Label>

                        <Checkbox onChange={(e) => this.setChecked("includeTax", e.checked)}
                                  name="includeTax"
                                  disabled={
                                      !(
                                          this.state.licenseSaveButtonRender &&
                                          this.state.license.purchaseOrderStatus !== "CLOSED" &&
                                          this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED"
                                      )
                                  }
                                  value={this.state.license.includeTax}
                                  checked={this.state.license.includeTax}></Checkbox>


                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="firstName">
                            <Translate contentKey="productfirstName">Use Invoice Barcode&nbsp;</Translate>
                        </Label>

                        <Checkbox onChange={(e) => this.setChecked("useInvoiceBarcode", e.checked)}
                                  name="useInvoiceBarcode"
                                  disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED" && !this.checkSupplierApproved())}
                                  value={this.state.license.useInvoiceBarcode}
                                  checked={this.state.license.useInvoiceBarcode}></Checkbox>


                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="firstName">
                            <Translate contentKey="productfirstName">Ignore Box Quantity&nbsp;</Translate>
                        </Label>

                        <Checkbox onChange={(e) => this.setChecked("readBoxQuantityFromProduct", e.checked)}
                                  name="readBoxQuantityFromProduct"
                                  disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED" && !this.checkSupplierApproved())}
                                  value={this.state.license.readBoxQuantityFromProduct}
                                  checked={this.state.license.readBoxQuantityFromProduct}></Checkbox>


                    </AvGroup>
                </Col>


                <Col>
                    <Dialog
                        visible={this.state.displayDialogFilter}
                        header={"Supplier"}
                        onHide={this.closeDisplayDialogFilter}
                        style={GeneralUtils.getDialogStyleForSupplierFilter()}
                    >
                        <SupplierFilter
                            ref={(elem) => (this.refModelCredentialsSave = elem)}
                            onDataSelect={this.onDataSelectFilter}
                            closeDisplayDialog={this.closeDisplayDialogFilter}
                        />
                    </Dialog>
                </Col>
            </>
        );
    }


    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
        this.popDialogHistory();
    }

    onDataSelectFilter = (data) => {
        let license = this.state.license;
        license["supplierId"] = data.id;
        license["supplierName"] = data.name;
        license["supplierBssId"] = data.bssId;
        license["supplierAccountCode"] = data.supplierAccountCode;
        license["supplierVatNumber"] = data.vatNumber;
        license["postcode"] = data.postcode;
        license["supplierPhoneNumber"] = data.phone;


        this.setState({
            license: license,
            displayDialogFilter: false
        }, () => {

        });


    }
    calculateFields = (product, field) => {
        try {
            const newProduct = {...product};
            const HUNDRED = new Decimal(100);

            if (field === "barcode") {
                newProduct['ItemBssId'] = null;
                newProduct['barcodeIsSearched'] = false;
            }

            newProduct['recommendedSalePrice'] = null;
            newProduct['actualMargin'] = null;
            newProduct['unitCost'] = null;
            newProduct['costPrice'] = null;
            newProduct['taxPrice'] = null;

            if (GeneralUtils.isNullOrEmpty(newProduct['barcode'])) {
                newProduct['itemBssId'] = null;
            }

            const boxQty = new Decimal(newProduct.boxSize || 1);
            const deliveryQuantity = new Decimal(newProduct.deliveryQuantity || 1);
            const totalPrice = new Decimal(newProduct.totalPrice || 0.0);
            const profitMargin = new Decimal(newProduct.profitMargin || 0.0);
            const vatRate = new Decimal(newProduct.taxRate || 0.0);

            // boxPrice = totalPrice / deliveryQuantity
            const boxPrice = deliveryQuantity.isZero()
                ? new Decimal(0)
                : totalPrice.div(deliveryQuantity).toDecimalPlaces(6);

            newProduct['boxPrice'] = parseFloat(
                boxPrice.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
            );


            // Cur. Unit Cost - hesaplanan alan (currentBoxPrice / currentBoxSize veya boxSize)
            const divisorForUnitCost = newProduct.currentBoxSize ?? newProduct.boxSize;
            if (
                newProduct.currentBoxPrice != null &&
                divisorForUnitCost != null &&
                Number(divisorForUnitCost) !== 0
            ) {
                newProduct.currentUnitCost = parseFloat(
                    new Decimal(newProduct.currentBoxPrice)
                        .div(new Decimal(divisorForUnitCost))
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
                        .toString()
                );
            } else {
                newProduct.currentUnitCost = null;
            }


            let unitCost;
            if (boxPrice == null || boxQty == null || boxQty.isZero()) {
                unitCost = new Decimal(0);
            } else {
                unitCost = boxPrice
                    .div(boxQty)
                    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            }

            newProduct['unitCost'] = parseFloat(unitCost.toString());

            let costPrice = new Decimal(0);
            let taxPrice = new Decimal(0);

            if (this.state.license?.includeTax) {
                costPrice = unitCost.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                if (!costPrice.isZero() && !vatRate.isZero()) {
                    taxPrice = costPrice.times(vatRate)
                        .div(HUNDRED.plus(vatRate))
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                } else {
                    taxPrice = new Decimal(0);
                }
            } else {
                const vatMultiplierPrecise = vatRate.plus(HUNDRED).div(HUNDRED).toDecimalPlaces(6);
                if (unitCost.isZero()) {
                    costPrice = new Decimal(0);
                    taxPrice = new Decimal(0);
                } else {
                    costPrice = unitCost.times(vatMultiplierPrecise).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                    taxPrice = costPrice.minus(unitCost)
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                }
            }

            newProduct['costPrice'] = parseFloat(costPrice.toString());
            newProduct['taxPrice'] = parseFloat(taxPrice.toString());

            const marginMultiplier = profitMargin.plus(HUNDRED).div(HUNDRED);
            let recommendedSalePrice = costPrice.times(marginMultiplier).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

            const method =
                newProduct.tillPriceCalculationMethod && newProduct.tillPriceCalculationMethod.trim() !== ""
                    ? newProduct.tillPriceCalculationMethod
                    : this.state.license?.tillPriceCalculationMethod;

            if (method) {
                switch (method) {
                    case "NEAREST_9":
                        recommendedSalePrice = CalculationUtils.roundNearest9(recommendedSalePrice);
                        break;
                    case "NEAREST_49_99":
                        recommendedSalePrice = CalculationUtils.roundNearest49_99(recommendedSalePrice);
                        break;
                    case "NEAREST_00":
                        recommendedSalePrice = CalculationUtils.roundNearest00(recommendedSalePrice);
                        break;
                    case "NEAREST_50":
                        recommendedSalePrice = CalculationUtils.roundNearest50(recommendedSalePrice);
                        break;
                }
            }

            newProduct['recommendedSalePrice'] = parseFloat(recommendedSalePrice.toString());

            if (method !== "PRICE_MARK" && method !== "MANUAL_ENTRY") {
                if (newProduct.oldPrice != null && recommendedSalePrice < newProduct.oldPrice) {
                    newProduct['salePrice'] = newProduct.oldPrice;
                } else {
                    newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                }
            }

            const itemPrice = new Decimal(newProduct.salePrice || 0.0);
            if (!costPrice.isZero()) {
                newProduct['actualMargin'] = parseFloat(
                    itemPrice.div(costPrice).times(HUNDRED).minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
                );
                if (newProduct.salePrice === newProduct.recommendedSalePrice) {
                    newProduct['actualMargin'] = newProduct.profitMargin;
                }
            } else {
                newProduct['actualMargin'] = 0;
            }

            const profit = (new Decimal(newProduct.salePrice || 0))
                .minus(unitCost)
                .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            newProduct['profit'] = parseFloat(profit.toString());

            return newProduct;

        } catch (e) {
            console.error("calculateFields error:", e);
            return {...product};
        }

    }
    toggleProduct = () => {
        this.setState((prevState) => ({
            productOpen: !prevState.productOpen,
            costPricingOpen: prevState.productOpen // Product kapandıysa cost açılır
        }));
    }

    toggleCostPricing = () => {
        this.setState((prevState) => ({
            costPricingOpen: !prevState.costPricingOpen,
            productOpen: prevState.costPricingOpen // Cost kapandıysa product açılır
        }));
    }

    pushDialogHistory = () => {
        if (!this.dialogHistoryPushed) {
            window.history.pushState({dialog: true}, document.title, window.location.href);
            this.dialogHistoryPushed = true;
        }
    };

    popDialogHistory = () => {
        if (this.dialogHistoryPushed) {
            this.ignoreNextPopState = true;
            window.history.back();
            this.dialogHistoryPushed = false;
        }
    };

    handlePopState() {
        if (this.ignoreNextPopState) {
            this.ignoreNextPopState = false;
            return;
        }
        // When opened from Android WebView: close conflict dialog first if open
        if (this.refModelSave && typeof this.refModelSave.hasOpenConflictDialog === 'function' && this.refModelSave.hasOpenConflictDialog()) {
            this.refModelSave.closeConflictDialog();
            window.history.pushState(null, document.title, window.location.href);
            return;
        }
        if (this.state.displayDialog || this.state.displayDialogFilter) {
            this.setState({displayDialog: false, displayDialogFilter: false}, () => {
                this.dialogHistoryPushed = false;
                window.history.pushState(null, document.title, window.location.href);
            });
        }
    }

    handleBackButton() {
        // When opened from Android app: close conflict dialog first if open, then item dialog
        if (this.refModelSave && typeof this.refModelSave.hasOpenConflictDialog === 'function' && this.refModelSave.hasOpenConflictDialog()) {
            this.refModelSave.closeConflictDialog();
            return true;
        }
        if (this.state.displayDialog) {
            this.closeDisplayDialog();
            return true;
        }
        if (this.state.displayDialogFilter) {
            this.closeDisplayDialogFilter();
            return true;
        }
        sessionStorage.setItem("purchaseOrderMobile.skipRedirectToSave", "true");
        return false;
    }


}

PurchaseOrderMobileSave.propTypes =
    {
        license: PropTypes.object
    }
;
